import League from '@/classes/league';
import User from '@/classes/user';

let $User: User;

export default {
  state: {
    mine: [],
    public: [],
    activeLeague: null,
    totals: [],
    members:[]
  },
  mutations: {
    'leagues/active'(state: any, league: League) {
      state.activeLeague = league;
    },
    'leagues/mine'(state: any, leagues: Array<League>) {
      state.mine = leagues;
    },
    'leagues/public'(state: any, leagues: Array<League>) {
      state.public = leagues;
    },
    'leagues/races'(state: any, races: any) {
      state.races = races;
    },
    'leagues/totals'(state: any, totals: any) {
      state.totals = totals;
    },
    'leagues/admin/members'(state: any, members: any) {
      state.members = members;
    },
    'leagues/public/update/join'(state: any, league: League) {
      state.mine.push(league);
    },
    'leagues/public/update/leave'(state: any, league: League) {
      state.mine = state.mine.filter((item: any) => item.id != league.id);
    },
    'leagues/admin/update/edit'(state: any, league: League) {
      let leagueIndex = state.mine.findIndex(
        (item: any) => item.id == league.id
      );
      let data = state.mine;

      data.splice(leagueIndex, 1, league);

      state.mine = data;
    }
  },
  actions: {
    async 'leagues/getLeague'(contenxt: any, leagueId: number) {},
    'leagues/init'(context: any, user: User) {
      $User = user;
    },
    async 'leagues/mine/load'(context: any) {
      let closeLoader = await context.dispatch(
        'loader/start',
        'Loading Leagues...'
      );

      let leagues: Array<League> = await $User.service.getMyLeagues();
      leagues = leagues || [];

      leagues.sort((a: League, b: League): any => {
        if (a.isOfficial || b.isOfficial) return 1;
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
      });

      context.commit('leagues/mine', leagues || []);
      closeLoader();
    },
    async 'leagues/public/load'(context: any) {
      // let leagues = await $User.service.getPublicLeagues();
      // context.commit('leagues/public', leagues);
    },
    async 'leagues/races/load'(context: any) {
      // let races = await $User.service.getLeagueRaces();
      // context.commit('leagues/races', races);
    },
    async 'leagues/totals/load'(context: any) {
      // let totals = await $User.service.getLeagueTotals();
      // context.commit('leagues/totals', totals);
    },
    async 'leagues/public/join'(context: any, league: League) {
      // context.commit('leagues/public/update/join', payload);
      let closeLoader = await context.dispatch(
        'loader/start',
        'Joining League...'
      );
      try {
        await $User.service.joinPublicLeague(league);
        closeLoader();
        context.dispatch('interact/toast', { title: `Joined ${league.name}` });
        return true;
      } catch (e) {
        context.dispatch('interact/error', e.message);
      }
    },
    async 'leagues/public/leave'(context: any, league: League) {},
    async 'leagues/admin/edit'(context: any, payload: League) {
      context.commit('leagues/admin/update/edit', payload);
    },
    async 'leagues/admin/setMembers'(context: any, payload: any) {
      context.commit('leagues/admin/members', payload);
    }
  },
  getters: {
    getLeague: (state: any) => (id: any) => {
      return state.mine.find((league: any) => league.leagueId == id) || {};
    },
    getRace: (state: any) => (id: any) => {
      // return state.races.find((race: any) => race.id == id) || {};
    },
    'leagues/available': (state: any) => {
      // let myLeagueIds = state.mine.map((league: any) => league.leagueId);
      // return state.public.filter((league: any) => {
      //   return myLeagueIds.indexOf(league.leagueId) == -1;
      // });
    }
  }
};
